"use client";

import { useEffect, useState } from "react";

type UseIdleReadyOptions = {
  timeout?: number;
};

export const useIdleReady = (
  enabled: boolean,
  { timeout = 1200 }: UseIdleReadyOptions = {},
) => {
  const [idleReady, setIdleReady] = useState(() => !enabled);

  useEffect(() => {
    if (!enabled) {
      setIdleReady(false);
      return;
    }

    let cancelled = false;
    let timeoutHandle: number | null = null;
    let idleHandle: number | null = null;

    const markReady = () => {
      if (!cancelled) {
        setIdleReady(true);
      }
    };

    if (
      typeof window !== "undefined" &&
      typeof window.requestIdleCallback === "function"
    ) {
      idleHandle = window.requestIdleCallback(markReady, {
        timeout,
      });
    } else {
      timeoutHandle = window.setTimeout(markReady, 200);
    }

    return () => {
      cancelled = true;

      if (
        idleHandle !== null &&
        typeof window !== "undefined" &&
        typeof window.cancelIdleCallback === "function"
      ) {
        window.cancelIdleCallback(idleHandle);
      }

      if (timeoutHandle !== null) {
        window.clearTimeout(timeoutHandle);
      }
    };
  }, [enabled, timeout]);

  return idleReady;
};
